import { CREATE_PROJECT, UPDATE_PROJECT } from "../actions/projects";
import { CREATE_USERS, UPDATE_USERS } from "../actions/user_management";

import { OPEN_SIDEBAR } from "../actions/index";

export default function (state = false, action) {
    switch (action.type) {
        case CREATE_PROJECT:
            return false;
        case UPDATE_PROJECT:
            return false;
        case CREATE_USERS:
            return false;
        case UPDATE_USERS:
            return false;                         
        case OPEN_SIDEBAR:
            return true;            
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/sidebar.js